import React from 'react';
import QuizCatagoriesLoad from '../QuizCatagoriesLoad/QuizCatagoriesLoad';



const Quiz = () => {
    return (
        <div>
      
      <QuizCatagoriesLoad></QuizCatagoriesLoad>
        </div>
    );
};

export default Quiz;